import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { forgeApi } from '../..'
import {
  GetArtifactSharesRaw,
  GetArtifactSharesResponse
} from './getArtifactShares.types'

export const getArtifactShares = async (
  publicId: string
): Promise<GetArtifactSharesResponse> => {
  const response = await forgeApi.get<GetArtifactSharesRaw>(
    `/api/v1/artifacts/${encodeURIComponent(publicId)}/shares`
  )
  return {
    users: response.data.shares ?? [],
    orgs: response.data.org_shares ?? [],
    positions: response.data.position_shares ?? []
  }
}

export const GET_ARTIFACT_SHARES_QUERY_KEY = 'forge-artifact-shares'

export const useGetArtifactSharesQuery = (
  publicId: string,
  options?: ExtendableQueryOptions<GetArtifactSharesResponse>
) =>
  useQuery({
    queryKey: [GET_ARTIFACT_SHARES_QUERY_KEY, publicId],
    queryFn: () => getArtifactShares(publicId),
    ...options
  })
